module.exports = __webpack_public_path__ + "img/user-avatar.5bc9a8d7.svg";